import { useMediaQuery } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { CommentsForPostResponse, postsApi } from 'src/api/posts';
import { Sidebar } from 'src/components/common/Sidebar/Sidebar';
import { MuiModal } from 'src/components/material/MuiModal';
import { CommentsSide } from 'src/pages/ChallengePage/CommentsSide/CommentsSide';

import { useCommentViewingEngagement } from 'src/utils/commentEngagement';
import styles from './SelectedVideoModal.module.scss';

interface SelectedVideoModalProps {
  isOpenModal: boolean;
  setIsOpenModal: (open: boolean) => void;
  postId: string;
  videoUrl: string;
}

export const SelectedVideoModal: FC<SelectedVideoModalProps> = ({
  isOpenModal,
  setIsOpenModal,
  postId,
  videoUrl,
}) => {
  const [comments, setComments] = useState<CommentsForPostResponse>({
    result: [],
    children: [],
    pagination: { currentPage: 1, pageSize: 10 },
  });
  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery('(max-width:545px)');
  const isTablet = useMediaQuery('(max-width:769px)');

  const tribeId = comments.result.length > 0 ? comments.result[0].tribe_id : '';
  const { trackManually } = useCommentViewingEngagement({
    postId,
    tribeId,
    hasComments: comments.result.length > 0,
    autoTrack: false, // Don't auto-track since this is a modal that's manually opened
  });

  useEffect(() => {
    if (isOpenModal && postId) {
      postsApi
        .getCommentsForPost(postId)
        .then((res) => {
          setComments(res);
          setLoading(false);
        })
        .catch((error: any) => {
          console.error('Failed to fetch comments:', error);
        });
    }
  }, [isOpenModal, postId]);

  // Track comment viewing when modal opens and has comments
  useEffect(() => {
    if (isOpenModal && comments.result.length > 0 && tribeId) {
      trackManually();
    }
  }, [isOpenModal, comments.result.length, tribeId, trackManually]);

  return (
    <MuiModal
      open={isOpenModal}
      setOpen={setIsOpenModal}
      width={500}
      isVideoModal
    >
      <div className={styles.videoModalContent}>
        {!isMobile && <Sidebar />}
        <div className={styles.video}>
          {!isTablet && (
            <ReactPlayer
              url={videoUrl}
              controls
              playing={isOpenModal}
              width="100%"
              height="100%"
              className={styles.verticalPlayer}
            />
          )}
        </div>
        <div className={styles.commentsWrapper}>
          <CommentsSide
            commentsData={comments}
            postId={postId}
            loading={loading}
          />
        </div>
      </div>
    </MuiModal>
  );
};
